import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { AttributesPage } from '../../features/catalog/attributes-page'

export const Route = createFileRoute('/_app/product-attributes')({
  staticData: { crumb: 'productAttributes' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'products.read'),
  component: AttributesPage,
})
